import {} from "./Net.js";
export function clonePortEntry(entry) {
    return Object.assign(Object.assign({}, entry), { connection: entry.connection
            ? Object.assign({}, entry.connection) : undefined });
}
//# sourceMappingURL=clonePortEntry.js.map